import React, { Fragment, useState, useEffect } from 'react'
import AnimateHeight from 'react-animate-height'
import i18n from 'i18next'
import * as R from 'ramda'

import GrabIcon from '../../../assets/images/move-icon.svg'

import './questionAccordian.scss'
import Checkbox from '../../form/Checkbox'
import Button from '../../../UniformComponents/Button'

// Used in /presentation
const QuestionAccordian = (props) => {
    const [data, setData] = useState({
        categories: [],
    })
    const [codedOptions, setCodedOptions] = useState([])
    const [codingAccordian, setCodingAccordian] = useState({})

    const fetchData = async () => {
        const { question, type, appStore } = props
        const request = JSON.stringify({
            questionId: question.id,
            questionType: type,
            questionOptionId: null,
            filter: {
                state: [],
                surveyDataIds: [],
                question: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
                campaign: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
                responseDate: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
            },
        })
        const response = await appStore.http.post(`/report/v1/${appStore.survey.id}/textquestion`, request)

        const questionCoding = {}

        const labels = response.labels.map((label, index) => {
            const coding = R.pathOr([], ['categories', index], response)

            coding.forEach((category) => {
                questionCoding[category] ??= 0
                questionCoding[category] += 1
            })

            return {
                label,
                coding: new Set(coding),
            }
        })
        const otherKey = 'Other'
        const other = R.pick([otherKey], questionCoding)
        const total = Object.entries(questionCoding).reduce((a, [_, v]) => a + v, 0)
        const sortedQuestionCoding = Object.entries(R.omit([otherKey], questionCoding))
            .sort((a, b) => b[1] - a[1])
            .map(([k, v]) => ({
                name: k,
                value: v,
                pct: (v / (total ?? 1) * 100),
            }))

        setData({
            labels,
            categories: [...sortedQuestionCoding, { name: otherKey, value: other[otherKey] ?? 0, pct: (other[otherKey] ?? 0 / (total ?? 1) * 100) }],
        })
    }

    const loadCoding = async () => {
        const { question, appStore } = props

        try {
            await appStore.http.post(`/report/v1/${appStore.survey.id}/textquestion/${question.id}/code`, JSON.stringify({}))
            await fetchData()
        } catch (e) {
            console.error(e)
            appStore.addNotification(null, 'Error loading question coding', 'error')
        }
    }

    useEffect(() => {
        const { type } = props

        if (['TA', 'TX'].includes(type)) {
            fetchData()
        }
    }, [])

    const setCodingOption = (name, value) => {
        const { config } = props
        const [category, label] = name.split('_')
        const clonedOptions = codedOptions.slice()
        const categoryIndex = clonedOptions.findIndex((v) => v.name === category)

        if (value) {
            if (clonedOptions[categoryIndex].comments.length === 3) {
                clonedOptions[categoryIndex].comments.shift()
            }
            clonedOptions[categoryIndex].comments.push(label)
        } else {
            clonedOptions[categoryIndex].comments = clonedOptions[categoryIndex].comments.filter((v) => v !== label)
        }

        config.slide.coding = clonedOptions
        setCodedOptions(clonedOptions)
    }

    const updateCodedOptions = ({ name, value, b }) => {
        console.log('updateCodedOPtions', b)
        const { config } = props
        const { categories } = data
        const { pct } = categories.find((c) => c.name === name) ?? { pct: 0 }
        let clonedOptions = codedOptions.slice()

        if (value) {
            if (clonedOptions.length === 3) {
                clonedOptions.shift()
            }
            clonedOptions.push({
                name,
                pct,
                comments: [],
            })
        } else {
            clonedOptions = clonedOptions.filter((v) => v.name !== name)
        }

        config.slide.coding = clonedOptions
        setCodedOptions(clonedOptions)
    }

    const verbatim = () => {
        const { type } = props

        if (!['TA', 'TX'].includes(type)) return null

        const hasCategories = data.categories.some(({ value }) => value > 0)

        if (!hasCategories) {
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Button
                        label="Generate Coding"
                        cssClass="regular"
                        variant="tertiary"
                        onClick={loadCoding}
                    />
                </div>
            )
        }

        return (
            <>
                <div
                    style={{
                        padding: '20px',
                        background: '#FAFBFD',
                        borderRadius: '6px',
                        minHeight: '193px',
                        maxHeight: 'fit-content',
                    }}
                >
                    <p className="optionHeaders">Coded Options</p>
                    {data.categories.map(({ name, value }) => (
                        <Checkbox
                            label={`${name} (${value})`}
                            name={name}
                            onBlur={updateCodedOptions}
                            checked={codedOptions.find((o) => o.name === name)}
                        />
                    ))}
                </div>
                <div
                    style={{
                        marginLeft: '20px',
                        minHeight: '193px',
                        maxHeight: 'fit-content',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        flex: 1,
                    }}
                >
                    {codedOptions.map(({ name: category, comments }) => (
                        <div
                            style={{
                                border: '1px solid #CADAE1',
                                borderRadius: '6px',
                                background: '#FFF',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    background: '#FAFBFD',
                                    borderRadius: '6px',
                                    alignItems: 'center',
                                    padding: '10px',
                                }}
                                onClick={() => {
                                    setCodingAccordian({
                                        ...codingAccordian,
                                        [category]: !codingAccordian[category],
                                    })
                                }}
                            >
                                {category}
                                <i className={`fa-light fa-chevron-${codingAccordian[category] ? 'up' : 'down'}`} />
                            </div>
                            <AnimateHeight
                                duration={250}
                                height={codingAccordian[category] ? 'auto' : 0}
                                className={codingAccordian[category] ? 'question-content' : ''}
                                style={{
                                    padding: '10px',
                                }}
                            >
                                {data.labels.filter((label) => label.coding.has(category)).map(({ label }) => (
                                    <Checkbox
                                        name={`${category}_${label}`}
                                        label={label}
                                        checked={comments.includes(label)}
                                        onBlur={({ name, value }) => setCodingOption(name, value)}
                                    />
                                ))}
                            </AnimateHeight>
                        </div>
                    ))}
                </div>
            </>
        )
    }
    const renderQuestionItemFull = () => {
        const {
            question,
            provided,
            show,
            toggle,
            content,
            preview,
            options,
            titleContent,
            type,
            oid,
        } = props
        const questionLevel = oid
        const className = (!question.modifiable ? ' locked' : '')

        return (
            <div
                className="question-list-item-presentation"
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <div className="question-list-item-header-presentation">
                    <div className={`question-list-item-left-presentation q_${questionLevel}`} />
                    <div className={`question-list-item-right-presentation ${show ? 'expanded' : ''}`}>
                        <div className="question-list-item-right-top-presentation">
                            <img src={GrabIcon} alt="Grab icon" />
                            <div className={`chevron-container ${show ? 'expanded' : ''}`} onClick={toggle}><i className={`fa ${show ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" /></div>
                            <span className={className}>
                                {titleContent}

                            </span>
                        </div>
                        <div className="question-list-item-right-bottom-presentation">
                            <div className={`question-preview-presentation ${show ? 'expanded' : ''}`}>
                                {
                                    <>
                                        {options()}
                                    </>
                               || (
                                   <>
                                       <i className={`fa-light fa-eye ${show ? 'expanded' : ''}`} />
                                       <span className={show ? 'expanded' : ''}>{i18n.t('sw_preview', 'Preview')}</span>
                                   </>
                               )
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <AnimateHeight
                    duration={250}
                    height={show ? 'auto' : 0}
                    className={show ? 'question-content' : ''}
                >
                    {preview
                            && (
                                <div style={{ padding: 16 }}>
                                    <div style={{ display: 'flex' }}>
                                        {verbatim()}
                                        {content}
                                    </div>
                                </div>
                            )}
                </AnimateHeight>
            </div>
        )
    }

    return (
        <Fragment>
            {renderQuestionItemFull()}
        </Fragment>
    )
}

export default QuestionAccordian
